<template>

<div class='col-12'>
    <comments :conf='commentConfig' :id='id'></comments>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        props : ['id'],

        created() {
           
        },

        data() {
            return {
                isReady : false,

                commentConfig : {
                    preload : false,
                    alwaysOpen : true,
                    canComment : true,
                    updc       : 'model-comments',
                    url : {
                        get : 'cmt:gmc',
                        add : 'cmt:amc',
                        upd : 'cmt:umc'
                    }
                },
            }
        },

        methods : {

        }

    }
</script>
